import React, { useState } from "react";
import { resolvePath } from "@/res/helpers/ObjectHelpers";
import useForm from "@/res/hooks/Form/useForm";
import ExpandArrow from "@/res/assets/icons/chevron_down.svg";
import { States } from "@/res/data/CountrySpecific/UnitedStates/States";
import { useTranslation } from "react-i18next";

const useUsaStateOrgInput = (props) => {
    const [t] = useTranslation();

    const [open, setOpen] = useState(false);
    const { values, forceValue } = useForm({ key: props?.key, context: props?.context });
    const rule = props?.rule ?? props?.rules ?? {};

    const key = props?.key ?? "usaStateOrgInput";
    const elementStateId = `useUsaStateInput${key}`;
    const elementOrgId = `useUsaOrgInput${key}`;
    const context = props?.context;
    const value = context != null ? resolvePath(context?.state, key) : values[key];

    const handleChangeMiddleman = (e) => {
        let _value = {
            form: e?.target?.value ?? "",
            state: value?.state ?? {},
        };
        setValue(_value);
        isValid(_value);
    }

    const setValue = (value) => {
        forceValue(key, value);
    };

    const isValid = (v = null) => {
        let itemState = document.getElementById(elementStateId);
        let itemOrg = document.getElementById(elementOrgId);
        let _value = v != null ? v : value;

        if ((_value?.state?.id ?? -1) < 0) {
            itemState?.setCustomValidity?.("You must select a state");
            return false;
        }

        itemState?.setCustomValidity?.("");
        itemOrg?.setCustomValidity?.("");
        return true;
    }

    const selectOption = (index) => {
        let _value = {
            form: value?.form ?? "",
            state: {
                id: index,
                name: States[index]?.name ?? "N/A",
                abbreviation: States[index]?.ansi?.alphabetic ?? "??",
            },
        };
        setValue(_value);
        isValid();
    }

    const render = () => {
        return (
            <div className="phone-container">
                { props?.label &&
                    <label htmlFor={ elementOrgId }>
                        { props?.label }
                    </label>
                }

                <div className={ `input-container prefix ${props?.class}` }>
                    <div className={ `prefix-addon selection-addon ${props?.class}` } onClick={() => setOpen(!open)}>
                        <input
                            autoComplete="business-state"
                            className="hidden-input"
                            id={ elementStateId }
                        />
                        <label style={{ lineHeight: "36px" }}>
                            { value?.state?.abbreviation ?? t("site.signup._country._service.placeholder-state-select") }
                        </label>
                        <span>
                            <img src={ExpandArrow} alt=""/>
                        </span>

                        <div className={ "country-list" + (open ? " open" : "") }>
                            { States.map((key, index) => {
                                return (
                                    <div key={index} onClick={() => selectOption(index)} className={ index === (value?.state?.id ?? -1) ? "country-list-item-highlighted" : "" }>
                                        <div>
                                            <label>
                                                { key?.name } <span>{ key?.ansi?.alphabetic }</span>
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <input
                        id={ elementOrgId }
                        name={ key }
                        placeholder={ t("site.signup._country._service.placeholder-org-form-field") }
                        autoComplete="organizational-form"
                        value={ value?.form ?? "" }
                        onChange={ props?.onChange ?? handleChangeMiddleman}
                        onKeyUp={ props?.onKeyUp }
                        onFocus={ props?.onFocus }
                        className={ props?.class + (isValid() ? "" : " invalid") }
                        required={ rule?.required ?? true}
                        disabled={ rule?.disabled ?? false }
                    />
                </div>
            </div>
        );
    };

    return {
        value, render, isValid, setValue,
    };
};

export default useUsaStateOrgInput;
